<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <component :is="is" v-if="content" v-html="content"></component>
</template>

<script setup>
import { computed } from "vue";
import MarkdownIt from "markdown-it";

const markdownParser = new MarkdownIt({
  linkify: true,
  breaks: true,
  html: true
});

const content = computed(() => {
  if (!props.value) {
    return "";
  }

  if (typeof props.value === "string") {
    return props.asPlainText ? props.value : markdownParser.render(props.value);
  }

  return props.asPlainText ? props.value.plainText : props.value.html;
});

const props = defineProps({
  is: { type: String, default: "div" },
  asPlainText: { type: Boolean, default: false },
  value: { type: [Object, String], default: null }
});
</script>
